import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginScreen from './login/LoginScreen';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import LoginDashboard from './dashbaords/LoginDashboard';


// 🔻 New placeholder components (create these files)
import VisitorEntry from './visitors/VisitorEntry';
import VisitorApproval from './visitorsapproval/VisitorApproval';
import VisitorReports from './visitorsreports/VisitorReports';
import TeamManagement from './teammanagement/TeamManagement'; // Adjust path if needed
import WabaSettings from './settings/WabaSettings'; // Adjust path if needed
import SecurityMaterials from './settings/SecurityMaterials'; // Adjust path if needed
import EmailSettings from './settings/EmailSettings'; // Adjust path if needed

import VisitorReport from './visitors/VisitorReport';
import VisitorTypes from './settings/VisitorTypes';
import VisitPurposes from './settings/VisitPurposes'; // Adjust path if needed
import VisitorApprovalConfirm from './visitorsapproval/VisitorApprovalConfirm'; // ✅ Adjust path if needed
import VisitorGatePass from './visitorsapproval/VisitorGatePass';



//import VisitorOutProcess from './visitorout/VisitorOutProcess';
import VisitorOutProcess from './visitorout/VisitorOutProcess';
import VisitorOutProcessLIST from './visitorout/VisitorOutList'; // Adjust path if needed


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route path="/dashboard" element={<LoginDashboard />} />
        <Route path="/visitor-entry" element={<VisitorEntry />} />
        <Route path="/visitor-show" element={<VisitorReport />} />
        <Route path="/visitor-approval" element={<VisitorApproval />} />
        <Route path="/visitor-reports" element={<VisitorReports />} />
        <Route path="/team-management" element={<TeamManagement />} />

        <Route path="/settings/waba" element={<WabaSettings />} />
        <Route path="/settings/security-materials" element={<SecurityMaterials />} />
        <Route path="/settings/email" element={<EmailSettings />} />
        <Route path="/settings/visitor-types" element={<VisitorTypes />} />
        <Route path="/settings/visit-purposes" element={<VisitPurposes />} />
          <Route path="/visitor-approval/confirm" element={<VisitorApprovalConfirm />} />
          <Route path="/gatepass/print/:id/:timestamp" element={<VisitorGatePass />} />


<Route path="/visitor-out" element={<VisitorOutProcess />} />
<Route path="/visitor-out/list" element={<VisitorOutProcessLIST />} />

      </Routes>
    </Router>
  );
}

export default App;